/**
 * Selector that returns the number of questions.
 *
 * This does NOT include subQuestions.
 * Maybe it should be allowed to in the future? Cross that bridge later.
 */

import { createSelector } from 'reselect';

import getQuestions from './getQuestions';

export default createSelector(getQuestions, (questions = null) => {
  if (questions && questions?.length > 0) {
    return questions.length;
  }
  return 0;
});
